// このアプリが localStorage に書き込むキーの一覧。
// storybook/.storybook/preview.tsx は VRT のキャプチャを安定させるため、story 描画前に
// アプリ由来のキーだけを消している。以前はキー名のプレフィックス正規表現で判定していたが、
// 新しいキーを追加したときにこの一覧・正規表現のどちらかを更新し忘れると VRT が
// 静かに不安定になる（前の story が書いた値を次の story が読んでしまう）ため、
// アプリ側（useLocalStorageState の呼び出し・last-tenant.ts）と preview.tsx の両方が
// この一覧を唯一の真実として参照する形にする
export const APP_LOCAL_STORAGE_KEYS = {
  lastTenantId: 'mbfab:last-tenant-id',
  userInfoForLog: 'USER_INFO_FOR_LOG',
  printTargetFlags: 'SteelOrderMillsheetPrintForm',
  summaryColumnConfigs: 'steelOrderSummaryColumnConfigs_v20260804',
  headerLabelTextConfig: 'SteelOrderMillsheetPrintFormHeaderLabelTextConfig',
  steelOrderPrintZoom: 'SteelOrderMillsheetPrintFormZoom',
  steelOrderExcelColumnConfigs: 'steelOrderExcelColumnConfigs_v20260810',
  // ホーム（ミルシート一覧）の印刷ダイアログ用。v1 apps/frontend/client/src/components/MillsheetPrintForm/
  // MillsheetPrintForm.tsx と同じキー名にして、将来 v2 が v1 を置き換えたときに利用者の設定を引き継げるようにする
  millsheetPrintTargetFlags: 'PrintMillsheetListButton',
  millsheetSummaryColumnConfigs: 'summaryColumnConfigs_v20260518',
  millsheetExcelColumnConfigs: 'excelColumnConfigs_v20260518',
  // ホームのデータ出力タブ「すべての裏書情報を含める」（既定 OFF）
  millsheetExcelIncludeAllEndorsements: 'mbfab:millsheet-excel-include-all-endorsements',
  millsheetHeaderLabelTextConfig: 'MillsheetPrintFormHeaderLabelTextConfig202507',
  // 加工証明（剪断証明書一覧）の印刷ダイアログ用。v1 apps/frontend/client/src/components/
  // ShearingCertificatePrintForm/ShearingCertificatePrintForm.tsx と同じキー名にして、将来 v2 が v1 を
  // 置き換えたときに利用者の設定を引き継げるようにする
  shearingPrintTargetFlags: 'ShearingCertificatePrintForm',
  shearingSummaryColumnConfigs: 'shearingCertificateSummaryColumnConfigs_v20260518',
  shearingExcelColumnConfigs: 'shearingCertificateExcelColumnConfigs_v20260518',
  shearingHeaderLabelTextConfig: 'ShearingCertificatePrintFormHeaderLabelTextConfig',
  millsheetCsvImportMsPerRow: 'mbfab:csv-import-ms-per-row:millsheet',
  shearingCsvImportMsPerRow: 'mbfab:csv-import-ms-per-row:shearing-certificate',
  orderMatchingCsvImportMsPerRow: 'mbfab:csv-import-ms-per-row:order-matching',
} as const
